import React from 'react';
import { StyleSheet } from '../base_components';
import { NETWORKS } from '../../data/networks';

import Select from '../select';

const styles = StyleSheet.create({
  ethChainSelect: {},
});

type Props = {
  style?: any;
  value: string;
  onChange: (chain_id: string) => void;
};
type State = {};

const OPTIONS = NETWORKS.map((network) => ({
  value: String(network.chain_id),
  text: network.name,
}));

export default class EthChainSelect extends React.PureComponent<Props, State> {
  render() {
    const { style, value, onChange } = this.props;

    return (
      <Select
        style={[styles.ethChainSelect, style]}
        options={OPTIONS}
        value={value}
        onChange={onChange}
      />
    );
  }
}
